import React, { useEffect, useState } from 'react';
import './game.css';
import { useNavigate } from "react-router-dom";
import { useIdleTimer } from 'react-idle-timer';
import Swal from 'sweetalert2'

function Game() {
    const navigate = useNavigate()

    const [gameOver, setgameOver] = useState(false);
    const [counter, setcounter] = useState(0);
    
    useEffect(() => {
        document.querySelector('#fullScreen').addEventListener('click', () => jump())
        
        var character = document.getElementById("character");
        var block = document.getElementById("block");
        
        function jump(){
            if(character.classList === "animate"){return}
            character.classList.add("animate");
            setTimeout(function(){
                character.classList.remove("animate");
            },300);
        }

        if (gameOver) {
            setcounter(0)
            block.className = ''

        } else {
            block.className = 'moveBlock'
    
            var checkDead = setInterval(function() {
                let characterTop = parseInt(window.getComputedStyle(character).getPropertyValue("top"));
                let blockLeft = parseInt(window.getComputedStyle(block).getPropertyValue("left"));
        
                if(blockLeft<20 && blockLeft>-20 && characterTop>=140){
                    block.className = ''
                    setcounter(0)
                    setgameOver(true)
                    clearInterval(checkDead)
                }else{
                    setcounter(counter + 1)
                }
            }, 10);
        }

        return () => {
            clearInterval(checkDead)
        }
    }, [gameOver, counter]);

    const start = () => {
        setgameOver(false)
    }
    const handleOnIdle = () => {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'You were idle for too long!',
          })
        navigate('/idle')
      }
      
     useIdleTimer({
        timeout: 1000 * 60 * 10,
        onIdle: handleOnIdle,
      })

  return (
      <div id='fullScreen'>

        <div className="game">
    
            <h1 className='gameTitle'>Burger Tech Fun Game</h1>
            <div id="character"  ></div>
            <div id="block"></div>
            <h2 className='gameScore'>Score: <span id="scoreSpan">{Math.floor(counter/100)}</span></h2>

            {gameOver && 
            <div className='gameOver'>
                <div className='gameOverBody'>
                    <div>Game Over !</div>
                    <div className='gameOverBtnRow'>
                        <button onClick={() => start()}>Play Again</button>
                        <button onClick={() => navigate('/Browse')}>Return to Menu</button>
                    </div>
                </div>
            </div>}

        </div>
    </div>

  );
}


export default Game;
